import { TierLevel } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export const getTierLevelLabel = (tierLevel?: TierLevel | null) => {
  return $enum.mapValue(tierLevel).with({
    [TierLevel.catastrophic]: 'Catastrophic',
    [TierLevel.bronze]: 'Bronze',
    [TierLevel.expanded_bronze]: 'Bronze',
    [TierLevel.silver]: 'Silver',
    [TierLevel.gold]: 'Gold',
    [TierLevel.platinum]: 'Platinum',
    [TierLevel.none]: 'None',
    [$enum.handleUnexpected]: '',
    [$enum.handleUndefined]: '',
    [$enum.handleNull]: '',
  });
};
